import { IconButton } from '@coolblue-development/becky';
import DiscardIcon from '../../../../Icons/DiscardIcon';

interface DiscardButtonProps {
  onClick: () => void;
}

const DiscardButton = ({ onClick }: DiscardButtonProps): JSX.Element => {
  return (
    <IconButton
      onClick={onClick}
      data-testid="discard-button"
      iconSize="small"
      preset="text"
      sx={{
        width: 'auto',
        height: 'auto',
        padding: '8px',
        ':hover': { background: '#F3F3F3' }
      }}
    >
      <DiscardIcon />
    </IconButton>
  );
};

export default DiscardButton;
